/**
 * Provides branding data
 */

define([], ()=> {
    return {
        BRANDING_DOMAIN: window.location.hostname.split('.')[0] // e.g. custom-domain.guidewire.com gives "custom-domain"
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/branding/BrandingData.js
 **/